import { useLocations } from '@services/common/useLocation'
import { useTranslation } from 'react-i18next'

import { Label } from '@/components/ui/label'
import {
  TreeMultiSelect,
  type TreeSelectNode
} from '@/components/ui/tree-multi-select'

interface Props {
  value?: string[]
  onChange: (value: string[]) => void
  disabled?: boolean
}

export function LocationTreeSelect({ value = [], onChange, disabled }: Props) {
  const { t } = useTranslation('layout')
  const { data, isLoading } = useLocations()

  return (
    <div>
      <Label className="mb-1.5 block">{t('common.locations')}</Label>
      <TreeMultiSelect
        value={value}
        onChange={onChange}
        tree={(data as unknown as TreeSelectNode[]) ?? []}
        loading={isLoading}
        disabled={disabled}
        placeholder={t('common.select_location')}
      />
    </div>
  )
}
